import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type SyncJurnodesMutationVariables = Types.Exact<{
  caseId: Types.Scalars['ID']['input']
  userIdentifier?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type SyncJurnodesMutation = { syncJurnodes?: boolean | null }

export const SyncJurnodesDocument = gql`
  mutation SyncJurnodes($caseId: ID!, $userIdentifier: Int) {
    syncJurnodes(caseId: $caseId, userIdentifier: $userIdentifier)
  }
`
export type SyncJurnodesMutationFn = Apollo.MutationFunction<
  SyncJurnodesMutation,
  SyncJurnodesMutationVariables
>

/**
 * __useSyncJurnodesMutation__
 *
 * To run a mutation, you first call `useSyncJurnodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncJurnodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncJurnodesMutation, { data, loading, error }] = useSyncJurnodesMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      userIdentifier: // value for 'userIdentifier'
 *   },
 * });
 */
export function useSyncJurnodesMutation(
  baseOptions?: Apollo.MutationHookOptions<SyncJurnodesMutation, SyncJurnodesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SyncJurnodesMutation, SyncJurnodesMutationVariables>(
    SyncJurnodesDocument,
    options
  )
}
export type SyncJurnodesMutationHookResult = ReturnType<typeof useSyncJurnodesMutation>
export type SyncJurnodesMutationResult = Apollo.MutationResult<SyncJurnodesMutation>
export type SyncJurnodesMutationOptions = Apollo.BaseMutationOptions<
  SyncJurnodesMutation,
  SyncJurnodesMutationVariables
>
